import { setUKDictionary } from "../transcribe/en_UK.json";
import { en_US_to_ipa, setUSDictionary } from "../transcribe/en_US.json";
import { fetchJson } from "./fetchJson";

const en_US = 'en_US.json';
const en_UK = 'en_UK.json';

/** load all English dictionary files */
export async function loadEnglishDictionaries() {
  const entryCount = Object.getOwnPropertyNames(en_US_to_ipa).length;
  if (entryCount > 0) {
    // dictionaries already loaded
    return new Promise((resolve) => resolve('skipped'));
  }

  const p1 = fetchJson(en_US, dictionaryEvents);
  const p2 = fetchJson(en_UK, dictionaryEvents);
  return Promise.all([p1, p2]);
}

const dictionaryEvents = {
  gotJson(fileName: string, json: any) {
    switch (fileName) {
      case en_US:
        setUSDictionary(json as Record<string, string>);
        break;
      case en_UK:
        setUKDictionary(json as Record<string, string>);
        break;
    }
  },
  gotError(fileName: string, message: string) {
    console.log('error loading data', fileName, message)
  }
}
